export const environment = {
    production: true,
    apiUrl: 'https://admin.thenightrace.at',
};
